import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useChatStore } from '../../stores/chatStore';

import { ChatDebugger } from './ChatDebugger';
import { CanvasSidebar } from './canvas/sidebar';
import styles from './styles.module.css';
import { Chat } from './user-input/container';

export function ChatInterface() {
  const { t } = useTranslation('assistant');
  const searchParams = new URLSearchParams(window.location.search);
  const isDebugMode = searchParams.get('debug') === 'true';
  const isSidebarOpen = useChatStore.use.isSidebarOpen();
  const setSidebarOpen = useChatStore.use.setSidebarOpen();

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  return (
    <div className={styles.wrapper}>
      {isDebugMode && <ChatDebugger />}
      <div
        className={clsx(styles.chatArea, {
          [styles.sidebarOpen]: isSidebarOpen,
          [styles.sidebarClosed]: !isSidebarOpen,
        })}
      >
        <div
          style={{
            display: 'flex',
            padding: '16px 32px',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <h2 className={styles.title}>{t('chat.title')}</h2>
          {/* <ToggleAudio /> */}
        </div>

        <Chat />
      </div>
      <CanvasSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
    </div>
  );
}
